module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    class: _vm.getError ? 'is-error' : '',
    attrs: {
      "title": _vm.info,
      "label": _vm.label,
      "required": _vm.required
    }
  }, [(_vm.label) ? _c('span', {
    staticStyle: {
      "color": "#636363"
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.label) + "\n\n      "), (_vm.info) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.getError && _vm.getError.length) ? _c('div', {
    staticClass: "text-left mt-1",
    staticStyle: {
      "color": "#e66666",
      "font-size": "9pt"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.getError.join(', ')) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a13e7cfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/EdInputItem.vue
// module id = 1478
// module chunks = 44